import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'productUnit',
    serviceName: 'graphql',
    query: gql`
      query productUnit {
        productUnit {
          data {
            id
            title
          }
        }
      }
    `,
  },
  delete: {
    name: 'deleteProductUnit',
    serviceName: 'admin',
    query: gql`
      mutation deleteProductUnit($ids: [String]!) {
        deleteProductUnit(ids: $ids) {
          messages
        }
      }
    `,
  },
  current: {
    name: 'productUnit',
    serviceName: 'graphql',
    query: gql`
      query productUnit($ids: [String]) {
        productUnit(ids: $ids) {
          data {
            media {
              id
              title
            }
          }
        }
      }
    `,
  },
  assignment: {
    name: 'productUnit',
    serviceName: 'graphql',
    query: gql`
      query productUnit($ids: [String]) {
        productUnit(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
